import React from "react";
import {Loader} from "gd-react";
import gatewayCommandSocket from "../../services/gatewayCommandSocket";
import GatewayOps from "./GatewayOps";
import GatewayRpcOps from "./GatewayRpcOps";

// What GatewayRpcOps runs over the command channel; without all of them it cannot do its job.
export const RPC_OPS_METHODS = ['zigbee.permitJoin', 'gateway.uploadLogs', 'gateway.sshTunnel'];

// The hub's Ops tab. Only a Pi-Duck with a live command channel gets GatewayRpcOps. Anything
// else - another model, a Pi-Duck on firmware that predates RPC, one that is offline or has RPC
// switched off - gets GatewayOps, whose config flags the pi-duck firmware also acts on.
class GatewayOpsPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			// null while the hub is being asked; a non-Pi-Duck is never asked
			rpc: gatewayCommandSocket.isPiDuck(props.item) ? null : false,
		};
	}

	componentDidMount() {
		if (this.state.rpc === false) return;
		const self = this;
		gatewayCommandSocket.capabilities(this.props.item.id)
			.then(function (res) {
				if (self.unmounted) return;
				const methods = (res && res.methods) || [];
				self.setState({rpc: RPC_OPS_METHODS.every(m => methods.indexOf(m) !== -1)});
			})
			.catch(function () {
				// Could not ask: the flags still reach the hub on its next check-in
				if (self.unmounted) return;
				self.setState({rpc: false});
			});
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	render() {
		if (this.state.rpc === null) {
			return <div className={'page'}><Loader type={'circular'} size={50}/></div>;
		}
		const Ops = this.state.rpc ? GatewayRpcOps : GatewayOps;
		return <Ops {...this.props}/>;
	}
}

export default GatewayOpsPage;
